import styled from 'styled-components';

export const InputSliderContainer = styled.div`
  position: relative;
  display: block;
  width: 100%;
`;

export const InputSliderWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 0 16px 30px;
`;

export const Label = styled.span`
  display: block;
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgba(27, 27, 27, 0.87);
`;
